export default "__VITE_ASSET__82f95912__"